import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useSession } from 'next-auth/react';
import { withPageProtection } from '../components/withPageProtection';
import { actorTypes } from '../../config/common';
import { colors, H1 } from '../components';
import useMainContext from '../hooks/main-provider';
const Dashboard = dynamic(() => import('../views/Dashboard'));
const SetCurrentUserFirstAndLastNameModal = dynamic(() => import('../views/SetCurrentUserFirstAndLastNameModal'));

const Home = props => {
  const { data: session } = useSession();
  const { selectedOrganization } = useMainContext();
  const [showRequestCurrentUserFirstAndLastNameModal, setShowRequestCurrentUserFirstAndLastNameModal] = useState(false);

  useEffect(() => {
    if (session?.user && !session?.user?.name) {
      setShowRequestCurrentUserFirstAndLastNameModal(true);
    }
  }, [session?.user]);

  if (session?.user?.type === actorTypes.Marketing) {
    return (
      <div style={{ width: '80%', padding: 16 }}>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <H1 textAlign="left" color={colors.brand} className="m-0">
            {selectedOrganization && selectedOrganization.displayName ? selectedOrganization.displayName : ''}
          </H1>
        </div>
      </div>
    );
  }

  return (
    <>
      <Dashboard user={session?.user} {...props} />
      {showRequestCurrentUserFirstAndLastNameModal && <SetCurrentUserFirstAndLastNameModal />}
    </>
  );
};

export default withPageProtection(Home);
